import React from "react";
import "./navbar.scss";
import {
  Avatar,
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";

// Icons
import { AiOutlineMenu } from "react-icons/ai";
import { IoMdNotificationsOutline } from "react-icons/io";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";

// Image
import AdminImage from "../../assets/adminImage/admin-image.jpg";
import brandStore from "../../stores/brandStore";
import authStore from "../../stores/authStore";

const Navbar = ({ isOpenSidebar, setIsOpenSidebar }) => {
  const BrandStore = brandStore();
  const AuthStore = authStore();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNavigate = ({ whereNavigate }) => {
    navigate(`/${whereNavigate}`);
  };

  return (
    <>
      <div className="navbar">
        <div className="headerSection flex">
          <div className="menu flex">
            <IconButton
              onClick={() => setIsOpenSidebar(!isOpenSidebar)}
              className="icon"
            >
              <AiOutlineMenu />
            </IconButton>
            <div className="title">
              <h1>Welcome to {BrandStore.brand.brandName}</h1>
              <p>Hello {AuthStore.adminDetails.firstName}, Welcome back!</p>
            </div>
          </div>

          <div className="adminDiv flex">
            <IoMdNotificationsOutline className="icon" />
            <div className="adminImage">
              <img
                onClick={handleClick}
                src={AdminImage}
                alt="Admin Image"
                aria-controls={open ? "account-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
              />
            </div>
            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleClose}
              onClick={handleClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  // mt: 1.5,
                  "& .MuiAvatar-root": {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  "&:before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <MenuItem onClick={handleClose} sx={{ width: "170px" }}>
                <Avatar src={AdminImage} /> <p>My Profile</p>
              </MenuItem>
              <Divider />
              <MenuItem
                onClick={() => handleNavigate({ whereNavigate: "settings" })}
              >
                <ListItemIcon>
                  <SettingsIcon fontSize="small" />
                </ListItemIcon>
                <p>Settings</p>
              </MenuItem>
              <MenuItem
                onClick={async () => {
                  handleClose();
                  await AuthStore.signOut();
                  navigate("/");
                }}
              >
                <ListItemIcon>
                  <LogoutIcon fontSize="small" />
                </ListItemIcon>
                <p>Logout</p>
              </MenuItem>
            </Menu>
          </div>
        </div>
      </div>
      <Divider />
    </>
  );
};

export default Navbar;
